<template>
    <div class="news-content">
        <div class="new-detail-item" v-for="(item, index) in list" :key="index">
            <p class="title" v-if="item.type === 'title'">{{item.content}}</p>
            <div class="origin-box" v-if="item.type === 'origin'">
                <p>发布者：{{item.origin}}</p>
                <p>发布时间：{{item.date}}</p>
            </div>
            <p class="content-des" v-if="item.type === 'p'" v-html="item.content"></p>
            <img class="detail-img" v-if="item.type === 'img'" :src="item.url">
            <p class="subTitle" v-if="item.type === 'subTitle'">{{item.content}}</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style lang="scss" scoped>
.news-content{
    .new-detail-item{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:#282828;
        line-height:17px;
        text-align: left;
        .title{
            font-size:18px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            line-height:25px;
            margin-bottom: 10px;
        }
        .origin-box{
            display: flex;
            justify-content: flex-start;
            align-items: center; 
            margin-bottom: 10px;         
            p{
                margin-right: 20px;
                &:last-of-type{
                    margin-right: 0px;
                }
            }
        }
        .content-des{
            line-height:22px;
            margin-bottom: 10px;
        }
        .detail-img{
            width: 100%;
            margin-bottom: 10px;
        }
        .subTitle{
            line-height: 12px;
            text-align: center;
            margin-bottom: 10px;
        }
    }
}
</style>